import { render, staticRenderFns } from "./OrganisationCreateAndUpdate.vue?vue&type=template&id=ed1a0bce&scoped=true"
import script from "./OrganisationCreateAndUpdate.vue?vue&type=script&lang=ts"
export * from "./OrganisationCreateAndUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1a0bce",
  null
  
)

export default component.exports